
// const baseUrl = "http://localhost:3000/"
// const baseUrl = "https://preprod.hindustanloans.com/"
const baseUrl = "https://bap.hindustanloans.com/"

const buyerUrl = "prod"
// const buyerUrl = "bap"

// export const webSocketURL = "ws://localhost:3000"
// export const webSocketURL = "wss://preprod.hindustanloans.com"
export const webSocketURL = "wss://bap.hindustanloans.com"

export const login = baseUrl+'user/login';
export const validateToken = baseUrl+'user/validate-token';

export const getFilesUrl = baseUrl+'fu/get-files';
export const uploadFilesUrl = baseUrl+'fu/upload';
export const modifyFilesUrl = baseUrl+'fu/modify';
export const deleteFilesUrl = baseUrl+'fu/delete';
export const s3PreSignedUrl = baseUrl+'s3/upload-url';

export const register = baseUrl+'user/validate-new-user';
export const sendValidationCode = baseUrl+'user/send-validation-code';
export const validateCode = baseUrl+'user/validate-code';
export const resetPassword = baseUrl+'user/reset-password';
export const validateMobile = baseUrl+'user/validate-mobile';
export const userProfile = baseUrl+'user/get-my-profile';
export const profilePhoto = baseUrl+'user/photo';
export const userUpdate = baseUrl+'user/update-profile';
export const userLoanHistory = baseUrl+'user/loan-history';
export const userLoanEligibility = baseUrl+'user/get-loan-eligibility?loan_code=';
export const sendEmailOtpUrl = baseUrl+'user/verify-email?email=';
export const verifyEmailOtpUrl = baseUrl+'user/verify-email-otp?otp=';


// PL Endpoints
// Search
export const loanSearch = baseUrl+buyerUrl+'/loan_search';

// Select
export const select2Url = baseUrl+buyerUrl+'/select2';
export const getSelect2Response = baseUrl+buyerUrl+'/get_select_2_response';
export const select3Url = baseUrl+buyerUrl+'/select';
export const getSelect3Response = baseUrl+buyerUrl+'/get_select_3_response';

// HL KYC
export const hlKycUrl = baseUrl+'user/kyc/digilocker/sessions/init?txnId=';

// Init
export const init = baseUrl+buyerUrl+'/init';
export const initResponse = baseUrl+buyerUrl+'/get_init_response';

//Confirm
export const confirm = baseUrl+buyerUrl+'/confirm';
export const confirmResponse = baseUrl+buyerUrl+'/get_confirm_response';

//Update
export const update = baseUrl+buyerUrl+'/update';
export const updateResponse = baseUrl+buyerUrl+'/get_update_response';
export const consentUrl = baseUrl+buyerUrl+'/get_consent_url_for_loan';

//Ticket
export const getOrderList = baseUrl+buyerUrl+'/get_order_list';
export const getErrorTypeList = baseUrl+buyerUrl+'/get_error_type_list';
export const allTicket = baseUrl+'ticket/get_all_ticket';
export const raiseATicket = baseUrl+'ticket/raise_ticket2';
export const respondTicket = baseUrl+'ticket/ticket-respond';
